module Meevo.Plugins.DocsAndForms {
    interface IOptions {
        showResend?: boolean;
        showLaunch?: boolean;
    }

    export interface IDAFListModalOptions {
        forms: IClientFormService[];
        formCollectionState: Meevo.Plugins.AppointmentBook.FormCollectionStateEnum;
        appointmentServices: IAS[];
        options: IOptions;
    }

    export class DocsAndFormsFormListModal {
        headerKey: string;
        clients: any[];
        url: string;
        options: IOptions;

        static show(modalService: Meevo.Components.Modal.ModalService, options: IDAFListModalOptions, onComplete?: (...args) => any) {

            return modalService.showCustom({
                templateUrl: 'app/plugins/docsAndForms/components/form-list-modal/form-list.modal.html',
                controller: 'meevo.plugins.docsAndForms.DocsAndFormsFormListModal',
                controllerAs: 'vm',
                bindToController: true,
                multiple: true,
                skipHide: true,
                onComplete: onComplete,
                locals: options
            })
        }

        static $inject = [
            'meevo.plugins.docsAndForms.DocsAndFormsApiService',
            'meevo.AppSettings',
            '$mdDialog',
            '$sce',
            'meevo.components.common.DataService',
            'meevo.plugins.docsAndForms.DocsAndFormsService',
            'meevo.components.busy.BusyService',
            'meevo.components.modal.ModalService',
            '$translate',
            'forms',
            'formCollectionState',
            'appointmentServices',
            'options',
        ];

        constructor(
            private docsAndFormsApiService: DocsAndFormsApiService,
            private appSettings: Meevo.Components.Common.IAppSettings,
            private $mdDialog,
            private $sce,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            private docsAndFormsService: IDocsAndFormsService,
            private busyService: Meevo.Components.Busy.IBusyService,
            private modalService: Meevo.Components.Modal.IModalService,
            private $translate: angular.translate.ITranslateService,
            private forms: (IClientFormService)[],
            private formCollectionState: FormCollectionStateEnum,
            private appointmentServices: IAS[],
            options: IOptions
        ) {
            this.options = {
                showLaunch: true,
                showResend: true,
                ...options,
            }

            if (forms.length == 0) {
                this.headerKey = 'MESSAGE_NO_FORMS';
            } else if (formCollectionState == FormCollectionStateEnum.Booking) {
                this.headerKey = 'MESSAGE_FORM_BOOKING';
            } else if (formCollectionState == FormCollectionStateEnum.Checkin) {
                this.headerKey = 'MESSAGE_FORM_REQUIRED';
            }

            this.buildClients();
        }

        private buildClients() {
            this.docsAndFormsService
                .buildFormsAndClients(this.forms, this.appointmentServices, this.formCollectionState)
                .then(clients => {
                    this.clients = clients;
                });
        }

        loadForm(form: IClientFormService) {
            let appointmentService = _(this.appointmentServices).findWhere({ id: form.appointmentServiceId });
            let appointmentIsCheckedOut = appointmentService && appointmentService.finalState === Model.AppointFinalStateEnum.CheckedOut;
            if (appointmentIsCheckedOut && form.url) {
                window.open(form.url, '_blank');

                return;
            }

            const showFormRow: IShowFormOptionRow = {
                formDisplayName: form.displayName,
                formId: form.id,
                formUrl: form.formUrl,
                serviceId: form.appointmentServiceId
            };

            this.close();
            this.docsAndFormsService.showForm(showFormRow, form.clientId, form.appointmentId);
        }

        resendForm(form: IClientFormService) {
            this.busyService.start();

            this.docsAndFormsApiService.resendForm({
                clientId: form.clientId,
                formId: form.id, // form.id matches id used by Client Docs & Forms resendForm method
                appointmentId: form.appointmentId,
                appointmentServiceId: form.appointmentServiceId
            }).then(() => {
                this.busyService.stop();

                const message = this.$translate.instant('MESSAGE_FORM_SENT', {
                    formDisplayName: form.displayName
                });

                // Need to hide so don't see unsightly transparent affect when following modal is closed
                $('#docs-modal').hide();
                this.modalService
                    .message(message, Components.Modal.ModalTranslationModes.DoNotTranslate, true)
                    .then(() => {
                        this.close();
                    })
            }).finally(() => {
                this.busyService.stop();
            });
        }

        close() {
            this.$mdDialog.hide();
        }
    }

    angular.module('meevo.plugins.docsAndForms')
        .controller('meevo.plugins.docsAndForms.DocsAndFormsFormListModal', DocsAndFormsFormListModal);
}
